import React, { useState } from "react";
import { toast } from "sonner";
import AppShell from "../components/layout/AppShell";
import { Button, Card, Input, Label } from "../components/common/UIKit";
import { updateProfile } from "../api/agents";
import { useAuthStore } from "../store/authStore";
import { errMsg } from "../lib/utils";

export default function ProfilePage() {
  const user = useAuthStore((s) => s.user);
  const setUser = useAuthStore((s) => s.setUser);
  const [form, setForm] = useState({
    full_name: user?.full_name || "",
    phone_number: user?.phone_number || "",
  });
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const updated = await updateProfile(form);
      setUser(updated);
      toast.success("Profile updated");
    } catch (err) {
      toast.error(errMsg(err, "Update failed"));
    } finally { setSaving(false); }
  };

  return (
    <AppShell title="Profile" subtitle="Manage your account details.">
      <div className="w-full max-w-2xl mx-auto p-8">
        <Card data-testid="profile-card">
          <form onSubmit={submit}>
            <div className="mb-4">
              <Label>Email</Label>
              <Input data-testid="profile-email" value={user?.email || ""} disabled />
            </div>
            <div className="mb-4">
              <Label>Full name</Label>
              <Input
                data-testid="profile-name-input"
                value={form.full_name}
                onChange={(e) => setForm((f) => ({ ...f, full_name: e.target.value }))}
                required
              />
            </div>
            <div className="mb-6">
              <Label>Phone</Label>
              <Input
                data-testid="profile-phone-input"
                value={form.phone_number}
                onChange={(e) => setForm((f) => ({ ...f, phone_number: e.target.value }))}
              />
            </div>
            <Button data-testid="profile-save-button" type="submit" disabled={saving}>
              {saving ? "Saving..." : "Save changes"}
            </Button>
          </form>
        </Card>

        <Card className="mt-4">
          <h3 className="text-sm font-bold uppercase tracking-widest text-zinc-700 mb-2">Account</h3>
          <dl className="text-sm space-y-1">
            {/* <div className="flex justify-between"><dt className="text-zinc-500">Agent ID</dt><dd className="font-mono text-xs text-zinc-700">{user?.id}</dd></div> */}
            {/* <div className="flex justify-between"><dt className="text-zinc-500">Stripe customer</dt><dd className="font-mono text-xs text-zinc-700">{user?.stripe_customer_id || "—"}</dd></div> */}
            <div className="flex justify-between"><dt className="text-zinc-500">Status</dt><dd className="font-semibold">{user?.is_active ? "Active" : "Inactive"}</dd></div>
          </dl>
        </Card>
      </div>
    </AppShell>
  );
}
